import { Meta } from "../../interfaces/meta.interface";

type Fields = any;


const operations: { [key: string]: Meta<Fields> } = {
 
}

export default operations;